import { createAppDataActions } from './actions/appData';
import { createDealActions } from './actions/deals';
import { createPlanningActions } from './actions/planning';
import { createSessionActions } from './actions/session';

/* Actions de l'application liées à la session et à la navigation : chargement du profil et des
   données, ouverture des fenêtres, vue « en tant que », préparation des affectations. */
export function createAppActions(deps) {
  return {
    ...createAppDataActions(deps),
    ...createSessionActions(deps),
    ...createPlanningActions(deps),
    ...createDealActions(deps),
  };
}
